import { render, staticRenderFns } from "./MotivationMarginalityChart.vue?vue&type=template&id=1c182d48&scoped=true&"
import script from "./MotivationMarginalityChart.vue?vue&type=script&lang=js&"
export * from "./MotivationMarginalityChart.vue?vue&type=script&lang=js&"
import style0 from "./MotivationMarginalityChart.vue?vue&type=style&index=0&id=1c182d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c182d48",
  null
  
)

export default component.exports